import React from 'react';
import { QuestionMark, SubmitButton, CustomLink, InputWrapper } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { ButtonWrapper, Information, SelectDropdown } from '../Elements';
import { PeriodHelp } from '../Help';
import usePeriod from './hooks/usePeriod';
import { FlowEnum, ComponentsEnum } from '../../types';
import { MainLayout } from '../MainLayout';

interface Props {
  nextUrl: string;
  progress?: number;
  flow?: FlowEnum;
}

const Period: React.FC<Props> = (props: Props) => {
  const { nextUrl, progress, flow } = props;
  const {
    classes,
    t,
    listOfMonths,
    listOfYears,
    monthFrom,
    yearFrom,
    monthTo,
    yearTo,
    onMonthFromChange,
    onYearFromChange,
    onMonthToChange,
    onYearToChange,
    onSubmit,
    onSkip,
    toggleHelpModal,
  } = usePeriod(nextUrl);

  return (
    <MainLayout
      navigationId={ComponentsEnum.PERIOD}
      flow={flow}
      progress={progress}
      directAccess={false}
      t={t}
      pageTitle="page_title"
    >
      <HelpModal>
        <PeriodHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <QuestionMark onHelpClick={toggleHelpModal} title={t('title')}>
          <InputWrapper>
            <SelectDropdown value={monthFrom} items={listOfMonths} onChange={onMonthFromChange} />

            <SelectDropdown value={yearFrom} items={listOfYears} onChange={onYearFromChange} />

            <span>{t('to')}</span>

            <SelectDropdown value={monthTo} items={listOfMonths} onChange={onMonthToChange} />

            <SelectDropdown value={yearTo} items={listOfYears} onChange={onYearToChange} />
          </InputWrapper>
        </QuestionMark>

        <ButtonWrapper>
          <SubmitButton onClick={onSubmit}>{t('continue')}</SubmitButton>
          <Information>
            {t('or')}
            &nbsp;
            <CustomLink href="#/" onClick={onSkip} color="inherit" underline="always">
              {t('skip')}
            </CustomLink>
          </Information>
        </ButtonWrapper>
      </div>
    </MainLayout>
  );
};

export default Period;
